import i18next from "i18next";

import config from "../../app.config.json";
import { PlaceResponse } from "../../models";
import { HttpMethodType, HttpStatusCode } from "../http";
import ResponseError from "../http/ResponseError";

import HttpClient from "./HttpClient";

export default class PlaceClient extends HttpClient {
  private static readonly baseUrl = `${config.dtdt_base_url}/v1/design/place`;

  public static async getPlaces(
    token: string,
    continuationToken?: string,
    pageSize?: number,
    org?: string,
  ): Promise<PlaceResponse> {
    const param = new URLSearchParams();

    if (continuationToken) {
      param.append("continuationToken", continuationToken);
    }
    if (pageSize) {
      param.append("pageSize", pageSize.toString());
    }
    if (org) {
      param.append("org", org);
    }

    const query = `${this.baseUrl}/filter?${param}`;

    const response = await this.request(token, query, HttpMethodType.Get);

    if (!response.ok) {
      if (
        response.status === HttpStatusCode.Forbidden ||
        response.status === HttpStatusCode.Unauthorized
      ) {
        throw new ResponseError(i18next.t("api_error_msg.unauth"), response);
      } else {
        throw new ResponseError(i18next.t("api_error_msg.place_err"), response);
      }
    }

    return response.json();
  }
}
